import * as THREE from 'three'
import type { VisualParams } from '../../types'
import type { SharedUniforms } from '../AudioUniforms'

/** Common contract for a visual primitive. */
export interface Primitive {
  readonly object3D: THREE.Object3D
  /** Rebuilds the geometry when structural parameters change (e.g. density). */
  rebuild(params: VisualParams): void
  /** Called every frame (the shared uniforms are already updated). */
  update(params: VisualParams, time: number, dt: number): void
  dispose(): void
}

/** Base class with common utilities. */
export abstract class BasePrimitive implements Primitive {
  abstract object3D: THREE.Object3D
  protected uniforms: SharedUniforms

  constructor(uniforms: SharedUniforms) {
    this.uniforms = uniforms
  }

  abstract rebuild(params: VisualParams): void
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  update(_params: VisualParams, _time: number, _dt: number): void {}

  dispose(): void {
    this.object3D.traverse((o) => {
      const mesh = o as THREE.Mesh
      if (mesh.geometry) mesh.geometry.dispose()
      const mat = mesh.material as THREE.Material | THREE.Material[] | undefined
      if (Array.isArray(mat)) mat.forEach((m) => m.dispose())
      else mat?.dispose()
    })
  }
}
